import React from 'react'
import { inject,observer } from 'mobx-react'

import Tabs, { Tab } from 'material-ui/Tabs'
import PropTypes from 'prop-types'
import { withStyles } from 'material-ui/styles'
import classNames from 'classnames'
import AppBar from 'material-ui/AppBar'
import Toolbar from 'material-ui/Toolbar'
import Icon from 'material-ui/Icon'
import IconButton from 'material-ui/IconButton'
import Typography from 'material-ui/Typography'
import Button from 'material-ui/Button'
import Slide from 'material-ui/transitions/Slide'
import Dialog from 'material-ui/Dialog'
import List, {
  ListItem,
  ListItemIcon,
  ListItemSecondaryAction,
  ListItemText,
  ListSubheader,
} from 'material-ui/List'
import T from 'i18n-react'
import Avatar from 'material-ui/Avatar'
import Divider from 'material-ui/Divider'
import { indigo } from 'material-ui/colors'
import Checkbox from 'material-ui/Checkbox'
import Chip from 'material-ui/Chip'
import Popover from 'material-ui/Popover'
import { findDOMNode } from 'react-dom'


@inject('lehrplanstore','ui') @observer
class Lehrplan extends React.Component {
  render() {
    const ui = this.props.ui.lehrplan, { classes,label } = this.props

    return (
     <Dialog
      fullScreen
      open={ui.open}
      onClose={ui.handleClose}
      >
       <LehrplanContent
        classes={classes}
        onSelection={this.props.onSelection}
        label={label}
       />
     </Dialog>
    )
  }

  componentWillUpdate () {
    if (!this.props.lehrplanstore.lehrplan) {
      this.props.lehrplanstore.init(this.props.lehrplan,this.props.preSelection)
    }
  }

  componentWillReceiveProps () {
    this.props.lehrplanstore.init(this.props.lehrplan,this.props.preSelection)
  }

}

@inject('lehrplanstore','ui') @observer
class LehrplanContent extends React.Component {
  render () {
    const { classes,label } = this.props, ui = this.props.ui.lehrplan

    return (
     <div className={classes.root}>
       <AppBar className={classes.appBar}>
        <Toolbar>
         <IconButton color="inherit" onClick={ui.handleClose} aria-label="Close"> &times; </IconButton>
        </Toolbar>
       </AppBar>
       <CompetenceTabbar classes={classes} onSelection={this.props.onSelection} label={label} />
     </div>
    )
  }
}

@inject('lehrplanstore','ui') @observer
class CompetenceHolder extends React.Component {
  render () {
    const { classes,kompetenz,lehrplanstore,ui,label } = this.props, chipData = lehrplanstore.getChipData()

    return (
     <div className={classNames(classes.content,classes.smoothScrolling)}>

      <div className="chip-container">
       {!lehrplanstore.hasCompetenceSteps && <Typography type="subheading" component="p" style={{padding:20}}> {label} </Typography>}
       {chipData.map( ks => {
         return (
           <Chip
            className="lehrplan-chip"
            avatar={<Avatar className={ui.getZyklusColor(ks)}> {ui.getZyklusAsString(ks)} </Avatar>}
            key={ks.code}
            label={ks.code}
            onClick={this.openPopover.bind(this,ks)}
            onDelete={this.toggleCompetenceStep.bind(this,ks.id)}
            ref={ chip => {this.chip = chip} }
           />
         )
        })}
       <CompetenceStepPopover />
      </div>

      <div className="callout" style={{borderLeftColor:indigo[500]}}>
       <Typography type="display1"> { kompetenz.bereich } </Typography>
       <Divider className={classes.divider} />
       <Typography type="caption"> { kompetenz.aspekt } </Typography>
       <Typography component="p" type="subheading" className="kompetenz-text"> { kompetenz.beschreibung } </Typography>
      </div>

      <List subheader={<ListSubheader> {T.translate("lehrplan.pupilsCan")} </ListSubheader>}>

       {
        kompetenz.kompetenzstufen.map( (ks,index) => {
         return (
           <ListItem key={index} dense button divider={true} onClick={this.toggleCompetenceStep.bind(this,ks.id)}>
            <Avatar className={ui.getZyklusColor(ks)}> {ui.getZyklusAsString(ks)} </Avatar>
            <ListItemText primary={ks.kompetenzstufe} secondary={ks.code}/>
            <ListItemSecondaryAction>
             <Checkbox
              checked={lehrplanstore.isActiveCompetenceStep(ks.id)}
              disableRipple
              onChange={this.toggleCompetenceStep.bind(this,ks.id)}
             />
            </ListItemSecondaryAction>
           </ListItem>
         )
        })
       }
      </List>
     </div>
    )
  }

  toggleCompetenceStep (ksId) {
    this.props.lehrplanstore.toggleCompetenceStep(ksId, this.props.onSelection)
  }

  openPopover (ks) {
    const ui = this.props.ui.lehrplan, anchorEl = findDOMNode(this.chip)

    ui.setPopoverAnchorEl(anchorEl)
    ui.handleOpenStepPopover(ks)
  }
}

@inject('ui') @observer
export class CompetenceStepPopover extends React.Component {
  render () {
    const ui = this.props.ui.lehrplan, ks = ui.competenceStep
    return (
      <Popover
       anchorEl={ui.competenceStepAnchorEl}
       open={ui.stepPopoverOpen}
       onClose={ui.handleCloseStepPopover}
       anchorOrigin={{
        vertical: "center",
        horizontal: "center",
       }}
       transformOrigin={{
        vertical: "top",
        horizontal: "center",
       }}
      >
       {ks && <Typography type="subheading" className="lehrplan-competencestep-popover"> {ks.kompetenzstufe} </Typography>}
      </Popover>
    )
  }
}

@inject('lehrplanstore','ui') @observer
class CompetenceTabbar extends React.Component {
  render () {
    const { classes,lehrplanstore,ui,label } = this.props,
            kompetenz = lehrplanstore.getKompetenzByIndex(ui.lehrplan.selectedTab)

    return (
      <div>
       <AppBar className={classes.tabBar} color="default">
        <Tabs
         value={ui.lehrplan.selectedTab}
         onChange={this.selectTab}
         indicatorColor="primary"
         textColor="primary"
         scrollable
         scrollButtons="auto"
        >

         {lehrplanstore.lehrplan.map( kompetenz => {
          return (
            <Tab label={kompetenz.code} key={kompetenz.code} />
          )
         })}

        </Tabs>
       </AppBar>

       <CompetenceHolder
        index={ui.lehrplan.selectedTab}
        kompetenz={kompetenz}
        classes={classes}
        onSelection={this.props.onSelection}
        label={label}
       />

      </div>
    )
  }

  selectTab = (e,value) => {
    this.props.ui.lehrplan.selectTab(value)
  }
}


const styles = theme => ({
  root: {
    width: '100%',
    height:'100vh',
    zIndex: 1,
    overflow: 'hidden',
  },
  smoothScrolling:{
   'overflow-y':'scroll',
   '-webkit-overflow-scrolling': 'touch'
  },
  appBar: {
    position: 'absolute',
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  tabBar: {
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginTop: 56,
    [theme.breakpoints.up('sm')]: {
      marginTop: 64,
    },
  },
  flex: {
    flex: 1,
  },
  divider: {
    marginTop:5,
    marginBottom:5,
  },
  content: {
    width: '100%',
    overflow:'auto',
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    height: 'calc(100vh - 56px - 48px)',
    marginTop: 56 + 48,
    [theme.breakpoints.up('sm')]: {
      height: 'calc(100vh - 64px - 48px)',
      marginTop: 64 + 48,
    },
  }
})

Lehrplan.propTypes = {
  classes: PropTypes.object.isRequired,
}


export default withStyles(styles)(Lehrplan)



// WEBPACK FOOTER //
// ./src/components/lehrplan.js